export const environment={
  isController: false,
  mqttBroker: null as any,
  mqttPort: 0,
  churchId: 'will be filled in controller build',
  mqttProtocol: 'wss',
  vapidPubKey: "BJ3RJV249oG8rrPm_X-4k4DQjwjE7mgjDYM_lzS5gUm5BuC8knVADOZUz14s1YRHiyQOtuFoYYBbNebfvtllPc8",
  baseUrl:"/"
}
